import { render, staticRenderFns } from "./ResellerTrans.vue?vue&type=template&id=5d491dfe&"
import script from "./ResellerTrans.vue?vue&type=script&lang=js&"
export * from "./ResellerTrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports